import React from "react";
import { NavLink } from "react-router-dom";
import menu from "../img/menu.png";
import styles from "./MainNav.module.css";

const MainNav = () => {
  return (
    <div>
      <nav className={styles.linkContainer}>
        <ul className={styles.linkList}>
          <a href="#nowhere" className={styles.listHeader}>
            <img src={menu} className={styles.menuImg} alt="hamburger menu" />
          </a>
          <li className={styles.listItem0}>
            <NavLink className={`${styles.linkNav} ${styles.homeLink} `} to="/">
              Home
            </NavLink>
          </li>
          <li className={styles.listItem1}>
            <NavLink
              className={styles.linkNav}
              activeClassName={styles.active}
              to="/curiosity"
            >
              Curiosity Corner
            </NavLink>
          </li>
          <li className={styles.listItem2}>
            <NavLink
              className={styles.linkNav}
              activeClassName={styles.active}
              to="/contact"
            >
              Contact Me
            </NavLink>
          </li>
          <li className={styles.listItem3}>
            <NavLink
              className={styles.linkNav}
              activeClassName={styles.active}
              to="/projects"
            >
              Projects
            </NavLink>
          </li>
          <li className={styles.listItem4}>
            <NavLink
              className={styles.linkNav}
              activeClassName={styles.active}
              to="/cards"
            >
              Technologies
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default MainNav;
